var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-google-autocomplete',{key:_vm.component,ref:"ac",attrs:{"id":_vm.component,"classname":_vm.classname,"placeholder":"Address","types":_vm.addressArray},on:{"placechanged":_vm.getAddressData,"hook:mounted":_vm.setDefaultAddress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }